<script setup lang="ts">
import DraggerMenuState from "@/stores/DraggerMenuState";
import { trackTab } from "@/analytics/drawing-analytics";
import { DraggerType, Facade } from "@/drawing";
import Dragger from "./Dragger.vue";
import CanvasButton from "../CanvasButton.vue";

/** Outils de zoom du groupe Vue (la Règle a son propre outil, RulerTool). */
defineProps<{
  tool: "zoomWindow" | "zoomExtents";
}>();

function activateZoomWindow() {
  DraggerMenuState.setActiveDragger({ name: DraggerType.ZoomWindow }, "zoom");
  if (Facade.isInitialized) {
    Facade.view.activateZoomWindow();
  }
}

function zoomExtents() {
  trackTab("settings", "zoom_fit");
  if (Facade.isInitialized) {
    Facade.view.zoomExtents();
  }
}
</script>

<template>
  <Dragger
    v-if="tool === 'zoomWindow'"
    :config="{ name: DraggerType.ZoomWindow }"
    phosphor-icon="selection"
    :tooltip-text="$t('canvas:tools.zoomwindow.text')"
    :tooltip-title="$t('canvas:tools.zoomwindow.title')"
    @click="activateZoomWindow"
  />
  <CanvasButton
    v-else
    phosphor-icon="magnifying-glass-minus"
    :tooltip-text="$t('canvas:tools.zoomextent.text')"
    :tooltip-title="$t('canvas:tools.zoomextent.title')"
    @click="zoomExtents"
  />
</template>
